
<div class="banner full-bleed">
  <div class="banner-container">
    <div class="banner-image">
      <img ngSrcset="600w, 800w, 1000w, 1200w, 1400w, 1600w"
        class="img-fluid"
        loading="eager"
        fetchpriority="high" ng-img="true"
        [ngSrc]="'waldviertler-7496698078'"
           fill
      />
      </div>
    <div class="banner-overlay"></div>
    <div class="banner-text">
      <div class="container">
        <h1>Neues von GEA</h1>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-xl-3 hidden-xs"></div>
  <div class="col-xl-6 col-xs-12">
    <p class="m-5">Du möchtest immer die neuesten Informationen aus dem GEA Universum erhalten? Melde dich für unseren kostenlosen Email-Newsletter an. Der Versand erfolgt etwa einmal pro Woche. Eine Abmeldung ist jederzeit möglich.</p>
    <gea-shop-subscriptions-form/>
  </div>
  <div class="col-xl-3 hidden-xs"></div>
</div>